var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _c(
      "form",
      {
        staticClass: "sign-in is-centered",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.onSubmit($event)
          }
        }
      },
      [
        _c("img", { attrs: { src: _vm.logo, alt: "logo" } }),
        _c("h1", { staticClass: "title is-4 has-text-white" }, [
          _vm._v("\n      Recuperar Contraseña\n    ")
        ]),
        !_vm.sended
          ? [
              _c("AppInputEmail", {
                attrs: {
                  value: _vm.email,
                  loading: _vm.loading,
                  disabled: _vm.loading
                },
                on: { input: _vm.onChangeEmail, change: _vm.onChangeEmail }
              }),
              _c("ButtonSubmit", {
                attrs: {
                  loading: _vm.loading,
                  disabled: _vm.loading,
                  text: "recupera tu contraseña"
                }
              })
            ]
          : _c("div", { staticClass: "notification is-success" }, [
              _vm._v(
                "\n      Se envió un correo con un link para que puedas recuperar tu contraseña. "
              ),
              _c("br"),
              _vm._v(
                "\n      Por favor haz click en el enlace que viene en el correo.\n    "
              )
            ]),
        _c("LinkSignIn")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }